import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LicenseStudyAreaServiceService } from 'src/app/predictor/services/license-study-area-service.service';

@Component({
  selector: 'app-study-area-workflow',
  templateUrl: './study-area-workflow.component.html',
  styleUrl: './study-area-workflow.component.scss'
})
export class StudyAreaWorkflowComponent {

  constructor(private readonly studyAreaService : LicenseStudyAreaServiceService) {}

  ngOnInit() {
  this.studyAreaService.currentStep$.subscribe(step => {
    this.currentStep = step;
  });
}

    public currentStep = 0;

    public stepsItem: MenuItem[] = [
      { label: 'Draw Area' },
      { label: 'Review Details' }
    ];

}
